import { select, call } from "redux-saga/effects";
import cirrusClient from "../../../services/api/cirrus-client";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";


export function* tapActiveCallSaga(action) {
    const callId = action.payload;
    try {

        const { uid } = yield select(selectUserCredentials)
        const apiUrl = '?object=call'

        const params = {
            action: 'tap',
            uid: uid,
            listener: 'uid',
            callid: callId,
        };

        yield call(cirrusClient.post, apiUrl, params)

    } catch (error) {
        console.error('Error tapping into active call', error)
    }
}